<template lang="pug" src="./html/ArticlesMenu.pug"></template>

<script>

  import ContentMenuBase from './../ContentMenuBase'

  // Portfolio Items
  import ArticlesList from './ArticlesList'
  import ArticleChinaDigitalOverview from './ChinaDigitalOverview'
  import ArticleCryptoTradingIntroGuide from './CryptoTradingIntroGuide'
  import ArticleHalfMarathonFaceRecognition from './HalfMarathonFaceRecognition'
  import ArticleInstagramCodesQRARCodes from './InstagramCodesQRARCodes'
  import ArticleiPhoneReplacesWallet from './iPhoneReplacesWallet'
  import ArticleMacTVSpotifyNewsfeed from './MacTVSpotifyNewsfeed'
  import ArticleRunningTechTeams from './RunningTechTeams'
  import ArticleShanghaiCabRide from './ShanghaiCabRide'
  import ArticleSmartCityHelsinki from './SmartCityHelsinki'

  const COMPONENTS_LIST = []
  const COMPONENTS = {
    ArticlesList,
    ArticleChinaDigitalOverview,
    ArticleCryptoTradingIntroGuide,
    ArticleHalfMarathonFaceRecognition,
    ArticleInstagramCodesQRARCodes,
    ArticleiPhoneReplacesWallet,
    ArticleMacTVSpotifyNewsfeed,
    ArticleRunningTechTeams,
    ArticleShanghaiCabRide,
    ArticleSmartCityHelsinki
  }
  for (let component in COMPONENTS) {
    COMPONENTS_LIST.push(COMPONENTS[component])
  }

  export default {
    extends: ContentMenuBase,
    components: COMPONENTS,
    name: 'ArticlesMenu',
    beforeCreate () {
      this.contentManager.init(COMPONENTS_LIST, 'ArticlesMenu')
    }
  }

</script>

<style lang="sass" src="./../../style/carousel-menu.sass"></style>
